import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

import usePrivileges from '../../../Auth/usePrivileges';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';

import CommentDialog from "../../../Dialogs/CommentDialog";
import WarningDialog from '../../../Dialogs/WarningDialog';
import { LotStatus } from '../../../Types/Lot';

function ConfirmReviewButton() {

    const { t } = useTranslation();

    const {
        lotDetail: {
            summary: {
                businessUnitCode,
                currentStatus,
                processingStatus,
                isLocked
            },
            warnings
        },
        updateLotStatus
    } = useContext(LotDetailContext);
    const { canReview } = usePrivileges(businessUnitCode);

    const [disabled, setDisabled] = useState<boolean>(false);
    const [showReviewCommentDialog, setShowReviewCommentDialog] = useState<boolean>(false);

    useEffect(() => {
        switch (processingStatus) {
            case "Processing":
            case "Queued":
                setDisabled(true);
                break;
            default:
                switch (true) {
                    case currentStatus !== "ReadyToReview":
                        setDisabled(true);
                        break;
                    default:
                        setDisabled(false);
                }
        }

        if (isLocked) {
            setDisabled(true);
        }

    }, [currentStatus, processingStatus, isLocked]);

    const handleReviewCommentSave = (comment: string) => {
        updateLotStatus(LotStatus.ReadyToGrade, comment);
    };

    return (
        <>
            <Button variant="primary"
                onClick={() => setShowReviewCommentDialog(true)}
                disabled={disabled || !canReview}
                hidden={currentStatus === "Graded"}>
                {t('LotDetails.Summary.ConfirmReview')}
            </Button>
            <CommentDialog
                showDialog={warnings.length === 0 && showReviewCommentDialog}
                closeDialog={() => setShowReviewCommentDialog(false)}
                onSave={handleReviewCommentSave} />
            <WarningDialog
                showDialog={warnings.length > 0 && showReviewCommentDialog}
                closeDialog={() => setShowReviewCommentDialog(false)}
                onSave={handleReviewCommentSave}
                action="Review"
                warnings={warnings} />
        </>
    );
}

export default ConfirmReviewButton;